$('.steps__item__caption').on('click', function () {
    const $button = $(this);
    const $item = $(this).closest('.steps__item');
    const $content = $item.find('.steps__item__content');
    $('.steps__item__caption').not($button).removeClass('active');
    $('.steps__item__content').not($content).slideUp();
    $button.toggleClass('active');
    $content.slideToggle();
});